import _ from 'lodash';
import { create } from 'zustand';

export enum EQuestIcon {
  TELEGRAM = 'TELEGRAM',
  TWITTER = 'TWITTER',
  WALLET = 'WALLET',
  INTERNAL = 'INTERNAL',
  REFERRAL = 'REFERRAL',
}

export type TQuest = {
  id: string;
  name: string;
  description: string;
  rewardAmount: number;
  daily_quest: boolean;
  link: string | null;
  isCompleted: boolean;
  icon: EQuestIcon;
};

export interface IQuestsStore {
  quests: TQuest[] | null;
  setQuests: (quests: TQuest[]) => void;
  makeQuestStatusCompletedById: (questId: TQuest['id']) => void;
}

export const useQuestsStore = create<IQuestsStore>((set) => ({
  quests: null,
  setQuests: (quests) => set({ quests }),
  makeQuestStatusCompletedById: (questId: TQuest['id']) =>
    set((state) => ({
      quests: _.map(state.quests, (quest) =>
        quest.id === questId ? { ...quest, isCompleted: true } : quest,
      ),
    })),
}));
